<script setup lang="ts">
import { PERF_DEBUG } from '~/utils/constants'
import { useSeoHead } from '~/composables/useSeoHead'
import { useClientOs } from '~/composables/useClientOs'
const { localeMeta } = useAppI18n()

useSeoHead()
useClientOs()

useHead(() => ({
  htmlAttrs: {
    lang: localeMeta.language,
    dir: localeMeta.dir,
  },
  meta: [
    {
      key: 'viewport',
      name: 'viewport',
      content: 'width=1200',
    },
  ],
}))
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <ClientOnly>
    <DevSsrRequestInspector v-if="PERF_DEBUG" />
  </ClientOnly>
</template>
